import React, { useEffect, useState } from 'react';
import { Menu, X, Phone } from 'lucide-react';
import { Button } from '../Button';
import { Logo } from './Logo';
const NAV_LINKS = [{
  label: 'Services',
  href: '#services'
}, {
  label: 'Work',
  href: '#work'
}, {
  label: 'Process',
  href: '#process'
}, {
  label: 'About',
  href: '#about'
}, {
  label: 'Contact',
  href: '#contact'
}];
export function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <header className={`fixed inset-x-0 top-0 z-50 transition-all duration-500 ${scrolled ? 'border-b border-white/10 bg-pine-950/90 backdrop-blur-md' : 'border-b border-transparent bg-transparent'}`} data-id="element-196" data-mp="1ukh3tbo2o80u">
      <div className="mx-auto flex h-20 max-w-[1320px] items-center justify-between px-6 lg:px-10" data-id="element-197" data-mp="skni8vy984vg">
        <a href="#top" aria-label="Taylor Company — home" className="transition-opacity hover:opacity-80" data-id="element-198" data-mp="xj78v9nsm4u5">
          <Logo height={34} data-id="element-199" data-mp="12ap9fwlwm3el" />
        </a>

        <nav aria-label="Main" className="hidden items-center gap-9 lg:flex" data-id="element-200" data-mp="179a7bpdooazv">
          {NAV_LINKS.map(link => <a key={link.href} href={link.href} className="relative text-sm text-bone-100/80 transition-colors hover:text-bone-50 after:absolute after:-bottom-1.5 after:left-0 after:h-px after:w-0 after:bg-bone-50 after:transition-all after:duration-300 hover:after:w-full" data-id="element-201" data-mp="9m1h5h2qmdrj">
              {link.label}
            </a>)}
        </nav>

        <div className="hidden items-center gap-6 lg:flex" data-id="element-202" data-mp="1uze011pc2qc3">
          <a href="tel:+15633809640" className="flex items-center gap-2 text-sm text-bone-100/80 transition-colors hover:text-bone-50" data-id="element-203" data-mp="1v0yu6q7qk79f">
            <Phone className="h-3.5 w-3.5" aria-hidden="true" data-id="element-204" data-mp="3vzsrss1df2oq" />
            (563) 380-9640
          </a>
          <Button className="h-11 rounded-full bg-bone-50 px-6 text-sm font-medium text-pine-900 hover:bg-white" onClick={() => document.getElementById('contact')?.scrollIntoView({
          behavior: 'smooth'
        })} data-id="element-205" data-mp="3r1heg7bvaa1r">
            Get a Quote
          </Button>
        </div>

        <button type="button" onClick={() => setOpen(v => !v)} aria-label={open ? 'Close menu' : 'Open menu'} aria-expanded={open} className="flex h-11 w-11 items-center justify-center rounded-full border border-white/20 text-bone-50 lg:hidden" data-id="element-206" data-mp="38c1cdfkja9j8">
          {open ? <X className="h-5 w-5" aria-hidden="true" data-id="element-207" data-mp="2tlalqauohghp" /> : <Menu className="h-5 w-5" aria-hidden="true" data-id="element-208" data-mp="2pljoppek644q" />}
        </button>
      </div>

      {open && <div className="border-t border-white/10 bg-pine-950/95 px-6 pb-8 pt-4 backdrop-blur-md lg:hidden" data-id="element-209" data-mp="2fg1vum0i5qgk">
          <nav aria-label="Mobile" className="flex flex-col" data-id="element-210" data-mp="2k8lalmaxermy">
            {NAV_LINKS.map(link => <a key={link.href} href={link.href} onClick={() => setOpen(false)} className="border-b border-white/10 py-4 font-display text-2xl text-bone-50" data-id="element-211" data-mp="25k8969t2kgl2">
                {link.label}
              </a>)}
          </nav>
          <a href="#contact" onClick={() => setOpen(false)} className="mt-6 flex h-12 w-full items-center justify-center rounded-full bg-bone-50 text-sm font-medium text-pine-900" data-id="element-212" data-mp="335w8b2gwtd0a">
            Get a Quote
          </a>
        </div>}
    </header>;
}